export default {
  image: 'A2_5.png',
  pdf: '220922_WA-HWF_005_A2_5_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-HWF-005',
    technicalValues: {
      soundReductionIndex: {
        output: '51,4',
        value: 51.4
      },
      heatTransferCoefficient: {
        output: '0,19',
        value: 0.19
      },
      fireBehavior: {
        output: 'normalentflammbar (B2)',
        value: 'B2'
      },
      fireResistanceOuter: {
        output: 'F 60-B',
        value: 'F-60-B'
      },
      fireResistanceInner: {
        output: 'F 30-B',
        value: 'F-30-B'
      }
    },
    name: 'Wandaufbau mit Holzweichfaser l Aufbau 5',
    construction: {
      composition: [
        {
          output: 'mineralischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'min-1'
        },
        {
          output: '60 mm Sto-Weichfaserplatte M046',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'wmo46-60'
        },
        {
          output: 'ohne',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: null
        },
        {
          output: '≥ 60/160',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-160'
        },
        {
          output: '160 mm Holzwolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'ciww-160'
        },
        {
          output: '15 mm OSB-Platte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ib-15'
        },
        {
          output: '12,5 mm Gipskartonplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'in-12'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '255,5',
        value: 255.5
      }
    }
  }
}
